import ajax from '../utils/request'

const channelBApi = {
  /***************************渠道明细****************************** */
  // 请求渠道查询,日志（同一个）列表列表
  getChannelDetailList(params) {
    return ajax({
      url: '/channel/manage/detail',
      type: 'get',
      params: params
    })
  },
/***************************渠道账簿****************************** */
  getBookList(params) {
    return ajax({
      url: '/channel/manage/accountbook',
      type: 'get',
      params: params
    })
  },
/***************************自助结算审核****************************** */
// 自助结算审核列表数据
  getAutoAccountList(params) {
    return ajax({
      url: '/channel/manage/autoaccount',
      type: 'get',
      params: params
    })
  },
  // 编辑账单
  automaticBillGeneration(params) {
    return ajax({
      url: '/channel/manage/autoaccount/modify',
      type: 'post',
      params: params
    })
  },
  // 编辑银行卡信息
  editBank(params) {
    return ajax({
      url: '/channel/manage/autoaccount/addbank',
      type: 'post',
      params: params
    })
  },
/***************************银行卡配置****************************** */
  // 银行卡列表数据
  getBankList(params) {
    return ajax({
      url: '/channel/manage/bank',
      type: 'get',
      params: params
    })
  },
}

export default channelBApi
